<template>
  <v-app class="bg-soft">
    <img
      class="img-fluid"
      style="
        position: absolute;
        z-index: -999;
        min-height: 100%;
        max-height: 100%;
        width: 100%;
      "
      src="@/assets/images/login_background.jpg"
    />
    <div
      class="d-flex h-100 justify-content-center align-items-center mx-3"
      style="opacity: 0.8"
    >
      <div
        class="card shadow-lg overflow-hidden login-container"
        style="border-radius: 20px; width: 448px; height: 565px"
      >
        <div class="bg-soft">
          <div class="row p-5 text-center mx-5">
            <div v-if="companyLogo">
              <img
                :src="companyLogo"
                alt=""
                class="img.fluid mx-auto d-block w-50"
              />
            </div>
          </div>
        </div>
        <div class="card-body pt-0">
          <b-form class="px-4 py-5" @submit.prevent="tryToLogIn">
            <v-text-field
              v-model="username"
              :error-messages="validationMessages($v.username, 'Kullanıcı Adı')"
              @input="$v.username.$touch()"
              @blur="$v.username.$touch()"
              label="Kullanıcı Adı"
              placeholder="Kullanıcı Adınızı Giriniz"
              prepend-inner-icon="mdi-account"
              @keydown.enter="tryToLogIn()"
            ></v-text-field>

            <v-text-field
              v-model="password"
              :error-messages="validationMessages($v.password, 'Şifre')"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
              label="Şifre"
              placeholder="Şifrenizi Giriniz"
              prepend-inner-icon="mdi-key"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              @keydown.enter="tryToLogIn()"
            ></v-text-field>
            <div class="d-flex">
              <v-btn
                x-small
                depressed
                text
                class="ms-auto"
                @click="forgotPasswordDialog = !forgotPasswordDialog"
              >
                <i class="mdi mdi-lock me-1"></i>
                <span class="text-capitalize">Şifrenizi Mi Unuttunuz ?</span>
              </v-btn>
            </div>

            <div class="mt-3 text-center">
              <v-btn
                color="success darken-2"
                elevation="3"
                small
                raised
                :disabled="loading"
                :loading="loading"
                @click="tryToLogIn()"
                >GİRİŞ YAP
              </v-btn>
            </div>
          </b-form>

          <p class="text-center py-5">
            © {{ new Date().getFullYear() }} OFISCOM Yazılımları
          </p>
        </div>
        <!-- end card-body -->
      </div>
      <div class="mt-5 text-center"></div>
    </div>
    <ForgotPasswordDialog
      :showDialog="forgotPasswordDialog"
      @dialogChange="(e) => (forgotPasswordDialog = e)"
    ></ForgotPasswordDialog>
    <div v-if="showCustomerModal">
      <CustomerDialog></CustomerDialog>
    </div>
  </v-app>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ForgotPasswordDialog from "../../../components/login/ForgotPasswordDialog.vue";

import { validationMessages } from "@/validationMessages.js";

import { mapActions, mapState } from "vuex";
import CustomerDialog from "@/components/dashboard/Dashboards/CustomerDialog.vue";

export default {
  components: {
    CustomerDialog,
    ForgotPasswordDialog,
  },
  computed: {
    ...mapState("auth", ["loginStatusLoading", "showCustomerModal"]),
    ...mapState("settings", ["companyLogo"]),
  },
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      showPassword: false,
      forgotPasswordDialog: false,
      loading: false,
    };
  },
  validations: {
    username: {
      required,
    },
    password: {
      required,
    },
  },
  methods: {
    validationMessages,
    async tryToLogIn() {
      this.loading = true;
      this.$v.$touch();

      if (!this.$v.$invalid)
        await this.tryLogin({
          username: this.username,
          password: this.password,
        });
      this.loading = false;
    },
    ...mapActions("auth", ["tryLogin", "prepareShowCustomerModal"]),
  },
  mounted() {
    this.prepareShowCustomerModal();
  },
};
</script>

<style scoped>
@media screen and (min-width: 600px) {
  .bg-gradient {
    height: 100%;
    background: #2c3e50 !important; /* fallback for old browsers */
    background: -webkit-linear-gradient(
      to right,
      #3498db,
      #2c3e50
    ) !important; /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(
      to right,
      #3498db,
      #2c3e50
    ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  }
}

.login-container {
  animation-name: example;
  animation-duration: 0.8s;
  animation-timing-function: ease-in;
}

@keyframes example {
  from {
    opacity: 0.1;
    margin-top: -100px;
  }
  to {
    opacity: 1;
    margin-top: 0px;
  }
}
</style>
